import { create } from 'zustand';

type StudyCompareState = {
  currentStudyInstanceUID: string | null;
  priorStudyInstanceUID: string | null;
  isCompareMode: boolean;
  setCompare: (currentStudyInstanceUID: string, priorStudyInstanceUID: string) => void;
  clearCompare: () => void;
};

export const useStudyCompareStore = create<StudyCompareState>(set => ({
  currentStudyInstanceUID: null,
  priorStudyInstanceUID: null,
  isCompareMode: false,
  setCompare: (currentStudyInstanceUID, priorStudyInstanceUID) =>
    set({
      currentStudyInstanceUID,
      priorStudyInstanceUID,
      isCompareMode: true,
    }),
  clearCompare: () =>
    set({
      currentStudyInstanceUID: null,
      priorStudyInstanceUID: null,
      isCompareMode: false,
    }),
}));
